var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOne = function SvgOne(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#FF0851",
    rx: 14
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.41 14.047q0-1.33.935-2.23.923-.913 2.387-.913 1.462 0 2.387.912.936.91.936 2.231 0 1.342-.936 2.255-.936.899-2.387.898-1.452 0-2.387-.898-.935-.913-.935-2.255m1.666 0q0 .72.468 1.199t1.186.48q.72 0 1.187-.48.468-.492.468-1.199 0-.72-.468-1.187-.467-.48-1.187-.48-.719 0-1.186.48-.468.467-.468 1.187M21.195 17.2q-1.402 0-2.361-.863-.96-.864-.96-2.29.001-1.33.863-2.23.865-.913 2.255-.913 1.294 0 2.075.924.779.923.78 2.243v.444h-4.293q.132.6.667.924.534.323 1.337.324.995 0 1.919-.528v1.355q-.808.61-2.282.61m-1.642-3.765h2.625a1.25 1.25 0 0 0-.366-.858q-.34-.341-.893-.342-.564 0-.936.33-.369.33-.43.87M16.82 11.559q-.575-.654-1.607-.653-1.199 0-2.002.875l-.004-.782-1.686.009v6.036h2.33v-.013h-.01v-2.717l-1.07.706v-1.703l1.249-.873h1.496v4.6h1.882v-3.668q-.004-1.164-.578-1.817"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3 11h22v6H3z"
  })))));
};
export default SvgOne;